// Version: 1.0 - About Section Component
import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2>The Vision for headacheMD<span className="er-highlight">ER</span></h2>
          <p>
            A concept for dedicated emergency headache treatment centers designed to provide 
            specialized, rapid care for acute and severe headache conditions.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="about-icon">
              <i className="fa fa-lightbulb"></i>
            </div>
            <h3>The Concept</h3>
            <p>
              Imagine emergency facilities specifically designed for headache emergencies, staffed 
              by headache specialists who understand that severe headaches require specialized 
              intervention—not just general emergency care.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon er">
              <i className="fa fa-clock"></i>
            </div>
            <h3>Faster, Focused Care</h3>
            <p>
              Unlike traditional ERs where headache patients may wait hours, a dedicated headacheMD 
              ER would provide rapid triage and treatment specifically designed for acute headache 
              conditions.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon">
              <i className="fa fa-user-md"></i>
            </div>
            <h3>Expert Specialists</h3>
            <p>
              Envisioned to be staffed by neurologists and headache medicine specialists who 
              understand migraine, cluster headaches, and other severe headache disorders at 
              a deeper level.
            </p>
          </div>

          <div className="about-card">
            <div className="about-icon er">
              <i className="fa fa-procedures"></i>
            </div>
            <h3>Specialized Treatment</h3>
            <p>
              Access to advanced treatments including IV medication protocols, nerve blocks, 
              and other interventions specifically designed for severe headache relief.
            </p>
          </div>
        </div>

        <div className="about-disclaimer-box">
          <div className="disclaimer-icon-large">
            <i className="fa fa-exclamation-circle"></i>
          </div>
          <div className="disclaimer-content">
            <h4>Important Disclaimer</h4>
            <p>
              <strong>This website represents a concept only.</strong> headacheMD ER is not currently 
              affiliated with any emergency room or urgent care facility. This is a vision for what 
              specialized headache emergency care could look like in the future.
            </p>
            <p>
              <strong>If you are experiencing a headache emergency,</strong> including the worst headache 
              of your life, sudden severe headache, or headache with neurological symptoms, please 
              <strong>call 911</strong> or go to your <strong>nearest emergency room</strong> immediately.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
